<template>
    <div>
        <ubi-panel>
            <el-container>
                <el-aside width="30%">
                    <h3>{{ $t('posts.edit.formBienVenduTitle') }}</h3>
                    <p class="text-justify" v-html="$t('posts.edit.bienVenduSubtitle')"/>
                </el-aside>
                <el-main v-if="isCreatedForm">
                    <el-dialog :visible.sync="cancelSaisieBV" :title="$t('posts.bienVendu.cancelCreationBienVenduTitle')" width="30%">
                        <span>{{$t('posts.bienVendu.cancelCreationBienVenduText')}}</span>
                        <span slot="footer" class="dialog-footer">
                        <el-button @click="cancelSaisieBV = false">{{ $t('posts.dialog.cancel') }}</el-button>
                        <el-button @click="annuler" type="success">{{ $t('posts.dialog.confirm') }}</el-button>
                    </span>
                    </el-dialog>
                    <el-row :gutter="20">
                        <el-col :span="24">
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <PostFormObjectType :post="post"></PostFormObjectType>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.title') + ' *'" prop="titre">
                                <el-input v-model="post.titre" :disabled="false"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.reference') + ' *'" prop="reference">
                                <el-input v-model="post.reference" :disabled="false"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.initialPrice')"
                                          prop="prix"
                            >
                                <el-input v-model.number="post.prix" type="prix">
                                    <div slot="append">EUR</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.adText') + ' *'" prop="texte">
                                <el-input :rows="5" type="textarea" v-model="post.texte"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.livingSpace') + ' *'"
                                          prop="surface_habitable"
                            >
                                <el-input v-model.number="post.surface_habitable"
                                          type="surface_habitable">
                                    <div slot="append">m²</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.roomsNumber') + ' *'"
                                          prop="nb_pieces_logement"
                            >
                                <el-input v-model.number="post.nb_pieces_logement"
                                          type="nb_pieces_logement" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.energyConsumption') + ' *'"
                                          prop="dpe_valeur_conso">
                                <el-input   v-mask="'#################'" v-model.number="post.dpe_valeur_conso" type="dpe_valeur_conso">
                                    <template slot="append">KWh/m²/an</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="14">
                            <el-form-item label="Etiquette consommation énergetique *" prop="dpe_etiquette_conso">
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.dpe_etiquette_conso != '' && post.dpe_etiquette_conso != undefined && post.dpe_etiquette_conso != null"
                                           @click="post.dpe_etiquette_conso = null"
                                           circle></el-button>
                                <el-radio-group v-model="post.dpe_etiquette_conso">
                                    <el-col :span="3"><el-radio label="A"></el-radio></el-col>
                                    <el-col :span="3"><el-radio label="B"></el-radio></el-col>
                                    <el-col :span="3"><el-radio label="C"></el-radio></el-col>
                                    <el-col :span="3"><el-radio label="D"></el-radio></el-col>
                                    <el-col :span="3"><el-radio label="E"></el-radio></el-col>
                                    <el-col :span="3"><el-radio label="F"></el-radio></el-col>
                                    <el-col :span="3"><el-radio label="G"></el-radio></el-col>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="6" :xs="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.streetNumber')" prop="numero_voie">
                                <el-input v-model.number="post.numero_voie"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :md="6" :xs="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.streetType')">
                                <el-select
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                                    v-model="post.type_voie"
                                >
                                    <el-option
                                        :key="typeVoieChoice"
                                        :label="typeVoieChoice"
                                        :value="typeVoieChoice"
                                        style="text-transform:capitalize"
                                        v-for="typeVoieChoice in getTypeVoie"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :xs="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.streetName')">
                                <el-input v-model="post.nom_voie"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.postalCode')" prop="code_postal">
                                <el-autocomplete
                                    class="inline-input"
                                    v-model="post.code_postal"
                                    :fetch-suggestions="searchPostal"
                                    @select="selectPostal"></el-autocomplete>
                            </el-form-item>
                        </el-col>
                        <el-col :span="14">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.city')" prop="ville">
                                <el-input v-model.number="post.ville"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-main>
                <el-main v-else>
                    <el-dialog :visible.sync="cancelSaisieBV" :title="$t('posts.bienVendu.cancelCreationBienVenduTitle')" width="30%">
                        <span>{{$t('posts.bienVendu.cancelCreationBienVenduText')}}</span>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="cancelSaisieBV = false">{{ $t('posts.dialog.cancel') }}</el-button>
                            <el-button @click="annuler" type="success">{{ $t('posts.dialog.confirm') }}</el-button>
                      </span>
                    </el-dialog>
                    <el-row :gutter="20">
                        <el-col :span="24">
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.title') + ' *'" prop="titre">
                                <el-input v-model="post.titre" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.reference') + ' *'" prop="reference">
                                <el-input v-model="post.reference" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.prixVenduNet')" prop="prix_vendu_net">
                                <el-input v-model="post.prix_vendu_net"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.buyerFees')" prop="honoraires_negociation">
                                <el-input v-mask="'#################'" v-model.number="post.honoraires_negociation" type="honoraires_negociation">
                                    <div slot="append">EUR</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.sellerFees')" prop="prix_honoraire_vendeur">
                                <el-input   v-mask="'#################'" v-model.number="post.honoraires_negociation_vendeur"
                                            type="honoraires_negociation_vendeur">
                                    <div slot="append">EUR</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.livingSpace') + ' *'"
                                          prop="surface_habitable"
                            >
                                <el-input step="0.01" v-model="post.surface_habitable"
                                          type="number">
                                    <div slot="append">m²</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.salesAgreementDate')">
                                <el-date-picker
                                    v-model="post.date_compromis"
                                    format="dd/MM/yyyy"
                                    value-format="dd/MM/yyyy"
                                    placeholder="Date compromis">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="6" :xs="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.streetNumber')" prop="numero_voie">
                                <el-input v-model.number="post.numero_voie"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :md="6" :xs="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.streetType')">
                                <el-select
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                                    v-model="post.type_voie"

                                >
                                    <el-option
                                        :key="typeVoieChoice"
                                        :label="typeVoieChoice"
                                        :value="typeVoieChoice"
                                        style="text-transform:capitalize"
                                        v-for="typeVoieChoice in getTypeVoie"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :xs="24">
                            <el-form-item label="Nom de voie">
                                <el-input v-model="post.nom_voie"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.postalCode')" prop="code_postal">
                                <el-autocomplete
                                    class="inline-input"
                                    v-model="post.code_postal"
                                    :fetch-suggestions="searchPostal"
                                    @select="selectPostal">
                                </el-autocomplete>
                            </el-form-item>
                        </el-col>
                        <el-col :span="14">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.city')" prop="ville">
                                <el-input v-model="post.ville"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="24" :xs="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.buyerOrigin')">
                                <el-select
                                    placeholder="Choisir une origine"
                                    clearable
                                    filterable
                                    v-model="post.origine_acquereur"
                                >
                                    <el-option
                                        :key="origineAcquereurChoice"
                                        :label="origineAcquereurChoice"
                                        :value="origineAcquereurChoice"
                                        style="text-transform:capitalize"
                                        v-for="origineAcquereurChoice in getOrigineAcquereur"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-main>
            </el-container>
            <ButtonBienVendu v-if="isEditedForm" :post="post" @handleCommand="handleActionBtnBV" :isProcessing="isProcessing"/>
        </ubi-panel>
        <ubi-panel v-if="isCreatedForm">
            <PostFormGroupPhotosBV />
            <postImagesUpload :post="post" :desactiverChamp="false"/>
        </ubi-panel>

        <ubi-panel v-if="isCreatedForm">
            <PostFormContactInfoBV :post="post"/>
        </ubi-panel>

        <ubi-panel v-if="isCreatedForm">
            <el-container>
                <el-aside width="30%">
                    <h3>{{ $t('posts.edit.formBienVenduTitle') }}</h3>
                    <p class="text-justify" v-html="$t('posts.edit.bienVenduSubtitle')"/>
                </el-aside>
                <el-main>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Prix net vendeur"
                                          prop="prix_vendu_net"
                            >
                                <el-input   v-mask="'#################'" v-model.number="post.prix_vendu_net" type="prix_net_vendeur">
                                    <div slot="append">EUR</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Prix vendu frais d'agence inclus"
                                          prop="prix_vendu_fai"
                            >
                                <el-input   v-mask="'#################'" v-model.number="post.prix_vendu_fai" type="prix_net_fai">
                                    <div slot="append">EUR</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.salesAgreementDate')">
                                <el-date-picker
                                    v-model="post.date_compromis"
                                    format="dd/MM/yyyy"
                                    value-format="dd/MM/yyyy"
                                    placeholder="Date compromis">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :md="24" :xs="24">
                            <el-form-item :label="$t('posts.bienVendu.formCreation.buyerOrigin')">
                                <el-select
                                    :placeholder="$t('posts.bienVendu.formCreation.chooseOrigin')"
                                    clearable
                                    filterable
                                    v-model="post.origine_acquereur"
                                >
                                    <el-option
                                        :key="origineAcquereurChoice"
                                        :label="origineAcquereurChoice"
                                        :value="origineAcquereurChoice"
                                        style="text-transform:capitalize"
                                        v-for="origineAcquereurChoice in getOrigineAcquereur"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-main>
            </el-container>
            <ButtonBienVendu :post="post" @handleCommand="handleActionBtnBV" :isProcessing="isProcessing"/>
        </ubi-panel>
    </div>
</template>
<script>
import UbiPanel from '@/components/Panel.vue'
import browserContext from '@/components/BrowserContext.vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import PostFormObjectType from '@/pages/posts/components/PostFormObjectType.vue'
import postImagesUpload from '@/pages/posts/components/PostImagesUpload.vue'
import PostFormContactInfoBV from '@/pages/posts/components/PostFormContactInfoBV.vue'
import PostFormGroupPhotosBV from '@/pages/posts/components/PostFormGroupPhotosBV.vue'
import Vue from 'vue'
import ButtonBienVendu from '@/pages/posts/BienVendu/Components/ButtonBienVendu.vue'
import { getCodePostalVille } from '@/services/toolbox'
import {getFromSnake} from "@/helpers/functions/getFromSnake";

export default {
  name: 'FormBienVendu',
  components: {
    PostFormGroupPhotosBV,
    PostFormContactInfoBV,
    postImagesUpload,
    PostFormObjectType,
    UbiPanel,
    ButtonBienVendu
  },
  props: ['post', 'isProcessing'],
  inject: ['browserContext'],
  data () {
    return {
      cancelSaisieBV: false
    }
  },
  methods: {
    ...mapMutations('postsListImmo', [
      'setPost'
    ]),
    handleActionBtnBV (args) {
      const { action, post } = args
      this.$emit('handleActionBtnBV', { action: action, post: post, typeForm: this.$route.name.split('-')[0] })
    },
    annuler () {
      this.$ga.event('annonce', 'clic', 'annuler_bien_vendu', this.sitimmoUser.id)
      this.$router.go(-1) // parent is in charge
    },
    async searchPostal (queryString, cb) {
      const results = await getCodePostalVille(queryString, this.post.pays)
      if (results.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      const tab = Object.values(results.result)
      cb(tab)
    },
    selectPostal (item) {
      Vue.set(this.post, 'ville', item.ville)
      Vue.set(this.post, 'code_postal', getFromSnake(item, 'code_postal'))
    }
  },
  computed: {
    browserContext () {
      return browserContext
    },
    ...mapState('postsListImmo', ['filter']),
    ...mapGetters(['isSubUser', 'isImmo', 'isVo', 'isPromoteur', 'isCmi']),
    ...mapGetters('calendarSocialPosts', ['getListEventsByAnnonceByNetwork']),
    ...mapGetters('definitionDonneesListe', ['getDefinitionDonneesListeByCode']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    universe () {
      return this.sitimmoUser.univers
    },
    job () {
      return this.sitimmoUser.metier
    },
    sitimmoLogin () {
      return this.sitimmoUser.login
    },
    username () {
      return this.user.username
    },
    typeOffre () {
      return this.post.typeOffre
    },
    typeObjet () {
      return this.post.typeObjet
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    possedeInstagram () {
      return this.user.haveInstagramBV
    },
    possedeGMBBV () {
      return this.user.haveGMBBV
    },
    possedeFacebook () {
      return this.user.haveFacebookBV
    },
    possedeLinkedIn () {
      return this.user.possedeLinkedIn
    },
    getEventsAnnonce () {
      return this.getListEventsByAnnonceByNetwork(this.currentTab)
    },
    getTypeVoie () {
      const typeVoie = this.getDefinitionDonneesListeByCode('type_voie')
      if (typeVoie) {
        return typeVoie.values
      }
    },
    getOrigineAcquereur () {
      const origineAcquereur = this.getDefinitionDonneesListeByCode('origine_acquereur')
      if (origineAcquereur) {
        return origineAcquereur.values
      }
    },
    isCreatedForm () {
      return this.$route.name.split('-')[0] === 'new'
    },
    isEditedForm () {
      return this.$route.name.split('-')[0] === 'edit'
    }
  },
  beforeMount () {
    const codes = [
      'type_voie',
      'origine_acquereur'
    ]
    this.$store.dispatch('definitionDonneesListe/loadDefinitionDonneesListe', { codes: codes })
  }
}
</script>
<style>
.button_bv {
    margin-left: 14px !important;
}
</style>
